import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import api from "../lib/api";
import useSeo from "../hooks/useSeo";
import { sanitizeHtml } from "../lib/sanitize";
import { Loader2 } from "lucide-react";

const DynamicPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  const fetchPage = useCallback(() => {
    setLoading(true);
    setNotFound(false);
    api.get(`/pages/${slug}`)
      .then(({ data }) => setPage(data))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [slug]);

  useEffect(() => {
    fetchPage();
  }, [fetchPage]);

  useSeo(page?.seo || {}, page ? `${page.title} | DaddyAnna` : "DaddyAnna");

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center"><Loader2 className="animate-spin text-[#00ff87]" size={40} /></div>;
  }
  if (notFound || !page) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4 px-4 text-center">
        <h1 className="font-display text-5xl font-bold neon-green text-glow-green">404</h1>
        <p className="text-gray-400">This page does not exist.</p>
        <button onClick={() => navigate("/")} className="btn-neon px-6 py-3 rounded-xl font-semibold">Go Home</button>
      </div>
    );
  }

  return (
    <main>
      <PageHero crumb={page.title} title={page.title} />
      <section className="pb-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <div
              className="prose-da text-gray-300 leading-relaxed space-y-4"
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(page.content) }}
            />
          </Reveal>
        </div>
      </section>
    </main>
  );
};

export default DynamicPage;
